import type { DataNode } from './types';

/**
 * Next-offset rule for offset-paging a `DataNode[]` listing: advance by a full page until a short
 * (final) page signals the end. Returns `undefined` to stop. Shared by every offset-paged project-nodes
 * endpoint so the rule can't drift between them — each caller only supplies its own page size.
 */
export function createNextOffsetGetter(pageSize: number) {
  return (lastPage: DataNode[], allPages: DataNode[][]): number | undefined =>
    lastPage.length < pageSize ? undefined : allPages.length * pageSize;
}
